export const Z_INDEX_COPILOT_SIDEBAR = 1070;
export const Z_INDEX_NAV_COMPONENT_LOW = 1111;
export const Z_INDEX_NAV_COMPONENT_DEFAULT = 1211;
export const Z_INDEX_NAV_COMPONENT_ACADEMY = 1234;
export const Z_INDEX_DEMO_EXIT_CONFIRMATION = 1211100;
export const Z_INDEX_OVERLAY_SEARCH = 1211101;
export const Z_INDEX_MODAL_COMPONENT = 1211111;